var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.09 48.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #6f1d46;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.96,5.02c2.27,3.86,4.25,7.96,6.51,11.72-3.57,3.91-.58,10.61-.1,11.72,2.85,5.31,7.43,8.83,11.14,7.57,6.66,11,.24,.1,6.66,11.24C12.49,55.72-10.14,8.15,4.96,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.56,2.85c-.63,.43-.82,1.21-.43,1.79,2.07,3.57,4.25,7.19,6.42,10.76,.43,.58,1.21,.87,1.79,.48,1.59-.92,3.09-1.79,4.63-2.65,.63-.43,.82-1.3,.53-1.88-2.17-3.57-4.34-7.19-6.51-10.76-.34-.58-1.21-.77-1.78-.39-1.59,.92-3.09,1.79-4.63,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.12,33.39c-.63,.43-.82,1.21-.43,1.79,2.07,3.67,4.15,7.28,6.32,10.95,.29,.58,1.21,.87,1.78,.48,1.59-.92,3.09-1.79,4.63-2.65,.63-.39,.82-1.3,.53-1.88-2.17-3.67-4.25-7.28-6.42-10.95-.34-.58-1.21-.77-1.79-.39-1.59,.92-3.09,1.79-4.63,2.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.57a9a89a4fa2a33a0ec1fa7b4103045f.svg";
export { ForwardRef as ReactComponent };